// extracted by mini-css-extract-plugin
export default {"content-wrapper":"property-area-services-overview_content-wrapper__Vx5rz","title":"property-area-services-overview_title__RFQqm"};